// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentHeader_wrapper__UQas8","title":"ContentHeader_title__kCJyK"};